import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined'
import CheckListIcon from 'icons/CheckListIcon'
import { Bag05OutlineIcon, GroupAddIcon, InventoryOutlinedIcon } from 'opensolar-ui'
import { MAX_DISPLAYED_CATEGORIES, useSupplierScopedCategories } from 'pages/ordering/categoryConfig'
import { useMemo } from 'react'
import { HardwareSupplierFilterKeyType } from '../../pages/ordering/type'
import { SelectedMenu } from './constant'
import { MenuConfigType, SubMenuConfigType } from './type'

const BASE_SIDEBAR_MENU_CONFIG: MenuConfigType[] = [
  {
    type: SelectedMenu.BUY_HARDWARE,
    buttonLabel: 'Shop',
    amplitudeEventSource: 'hardware_sidebar_navigation_buy_hardware_button',
    amplitudeEventSourceV2: 'lhs_shop_button',
    redirectUrl: '/shop',
    routeRule: '^/shop(/search(/.*)?)?$',
    icon: <LocalShippingOutlinedIcon style={{ width: '20px', height: '20px' }} />,
    subMenu: [],
    subMenuHeading: 'Shop',
  },
  {
    type: SelectedMenu.ORDER_BY_PROJECT,
    buttonLabel: 'Multi-Project Ordering',
    amplitudeEventSource: 'hardware_sidebar_navigation_order_by_project_button',
    amplitudeEventSourceV2: 'lhs_multi_project_ordering_button',
    redirectUrl: '/multi_project_ordering',
    routeRule: '^/multi_project_ordering(/.*)?$',
    icon: <CheckListIcon />,
    subMenu: [],
    subMenuHeading: 'Multi-Project Ordering',
  },
  {
    type: SelectedMenu.MANAGE_ORDERS,
    buttonLabel: 'Manage Orders',
    amplitudeEventSource: 'hardware_sidebar_navigation_manage_orders_button',
    amplitudeEventSourceV2: 'lhs_manage_orders_button',
    redirectUrl: '/manage_orders/incoming_transfer',
    routeRule: '^/manage_orders(/.*)?$',
    icon: <Bag05OutlineIcon fill="none" width="21" height="20" />,
    subMenu: [{ title: 'Incoming POs', url: '/manage_orders/incoming_transfer' }],
    subMenuHeading: 'Manage Orders',
  },
  {
    type: SelectedMenu.QUOTES,
    buttonLabel: 'Quotes',
    amplitudeEventSource: 'hardware_sidebar_navigation_quotes_button',
    amplitudeEventSourceV2: 'lhs_quotes_button',
    redirectUrl: '/quotes',
    routeRule: '^/quotes(/.*)?$',
    icon: <GroupAddIcon size={30} />,
    subMenu: [],
    subMenuHeading: 'Quotes',
  },
  {
    type: SelectedMenu.INVENTORY_MANAGEMENT,
    buttonLabel: 'Inventory Management',
    amplitudeEventSource: 'hardware_sidebar_navigation_inventory_management_button',
    amplitudeEventSourceV2: 'lhs_inventory_management_button',
    redirectUrl: '/inventory/dashboard',
    routeRule: '^/inventory(/.*)?$',
    icon: <InventoryOutlinedIcon width="21" height="20" />,
    subMenu: [
      { title: 'Dashboard', url: '/inventory/dashboard' },
      { title: 'Inventory', url: '/inventory/location' },
      { title: 'Outgoing Orders', url: '/inventory/outgoing_transfer' },
      { title: 'Activity', url: '/inventory/activity' },
      { title: 'Insights', url: '/inventory/insights' },
      { title: 'Settings ', url: '/inventory/configuration' },
    ],
    subMenuHeading: 'Manage Inventory',
  },
]

export const useSidebarMenuConfig = (distributor?: HardwareSupplierFilterKeyType): MenuConfigType[] => {
  const visibleSupplierCategories = useSupplierScopedCategories(distributor)

  return useMemo(() => {
    // Cap the sidebar submenu at MAX_DISPLAYED_CATEGORIES to keep it aligned
    // with the homepage bento grid. Extras still flow through to filters and
    // routing — only this list-style surface is bounded.
    const visibleCategories = visibleSupplierCategories.slice(0, MAX_DISPLAYED_CATEGORIES)

    const shopSubMenu: SubMenuConfigType[] = [
      {
        title: 'Home',
        url: '/shop',
        amplitudeEventSource: 'hardware_sidebar_submenu_home_button',
        key: 'home',
      },
      ...visibleCategories.map((category) => ({
        title: category.name,
        url: `/shop/search/${category.searchKey}`,
        amplitudeEventSource: `hardware_sidebar_submenu_${category.searchKey}_button`,
        key: category.searchKey,
      })),
    ]

    return BASE_SIDEBAR_MENU_CONFIG.map((menu) => {
      if (menu.type === SelectedMenu.BUY_HARDWARE) {
        return { ...menu, subMenu: shopSubMenu }
      }
      return menu
    })
  }, [visibleSupplierCategories])
}
